export const getFuelFilter = state => state.fuel.filter
